export const sampleFlight = {
  departureCountry: "IT",
  arrivalCountry: "IT",
  departureTime: new Date("2027-07-01T10:00:00"), // "Z" for UTC Time
  arrivalTime: new Date("2025-08-01T19:00:00"), // "Z" for UTC Time
};
